// import Push from 'push.js'
export default {
  // notifyMe: function () {
  //   Push.create('Ekincare', {
  //     body: 'Patient is Waiting..',
  //     icon: '/static/ekincarelogo.png',
  //     timeout: 4000,
  //     onClick: function () {
  //       window.focus()
  //       this.close()
  //     }
  //   })
  // },
  create: function (type) {
    if (type === 'msg') {
      this.newMessageSound()
    } else if (type === 'newuser') {
      // this.notifyMe()
      this.newUserSound()
    }
  },
  newMessageSound: function () {
    var audio = new Audio()
    if (typeof Audio !== 'undefined') {
      if (audio.canPlayType('audio/ogg') === 'probably') {
        audio = new Audio('/static/sounds/msg_received.ogg')
      } else {
        audio = new Audio('/static/sounds/msg_received.mp3')
      }
      audio.play().then().catch(e => console.log(e))
    } else {
    }
  },
  newUserSound: function () {
    var audio = new Audio()
    if (typeof Audio !== 'undefined') {
      if (audio.canPlayType('audio/ogg') === 'probably') {
        audio = new Audio('/static/sounds/waiting.ogg')
      } else {
        audio = new Audio('/static/sounds/waiting.mp3')
      }
      audio.play().then().catch(e => {
        console.log(e)
      })
    } else {
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/alerts.js